import { render, staticRenderFns } from "./clientdashboard-new-activities.vue?vue&type=template&id=266e7eac&"
import script from "./clientdashboard-new-activities.vue?vue&type=script&lang=js&"
export * from "./clientdashboard-new-activities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports